/* eslint-disable */

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { utility } from "../../../utility/utilityProvider";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { LOCALSTORAGE_KEY } from "../../../constant/constant";

//to show item stored in array on collection
export const MultiLangArrayCell = (props) => {

    const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    
    const field = props?.field || "";
    var fieldValue = '';
    var displayValue = '';

    if (field.includes('.')) {
        //For field value coming as example :- MediaCategory.Duration
        var keys = field.split('.');
        fieldValue = props.dataItem[keys[0]] ?
            props.dataItem[keys[0]][keys[1]] ? props.dataItem[keys[0]][keys[1]] : ''
            : '';
    } else {
        fieldValue = props.dataItem[field];
    }

    if (fieldValue == undefined || fieldValue.length == 0) {
        displayValue = '';
    } else if (typeof fieldValue == 'string') {
        displayValue = fieldValue;
    } else {
        displayValue = fieldValue?.find((x) => x.langISO == props?.selectedLang?.ISOCode ?? Company?.Language?.ISOCode) ?
            fieldValue.find((x) => x.langISO == props?.selectedLang?.ISOCode ?? Company?.Language?.ISOCode).value :
            fieldValue[0]['value'];
    }

    return <td
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        {...useTableKeyboardNavigation(props.id)}
        {...{
            [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
        }}
        style={props.style}>
        {utility.subString(displayValue, 30)}
    </td>;
};